// extracted by mini-css-extract-plugin
export default {"NavbarWrapper":"NavbarWrapper_NavbarWrapper__8v1I+"};